import { Injectable } from '@angular/core';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
  LogLevel,
} from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MSALConfigurationServiceService {
  static protectedResourceMap: [string, string[]][] = [
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
  ];

  constructor() {}

  static isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1;

  static MSALInstanceFactory() {
    return new PublicClientApplication({
      auth: {
        clientId: environment.authConfig.clientId,
        authority:
          'https://login.microsoftonline.com/' + environment.authConfig.tenant, // 'https://login.microsoftonline.com/common/',
        redirectUri: environment.authConfig.redirectUri, // 'http://localhost:4200/auth',
        postLogoutRedirectUri: '/logged-out',
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: this.isIE, // set to true for IE 11
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    });
  }

  static MSALInterceptorConfigFactory() {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', [
      'user.read',
    ]);
    environment.authConfig.addedProtectedResourceMap.map((i) => {
      protectedResourceMap.set(i.key, i.list);
    });

    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }

  static MSALGuardConfigFactory() {
    return {
      interactionType: InteractionType.Redirect,
      loginFailedRoute: '/',
    };
  }
}

export function loggerCallback(logLevel: LogLevel, message: string) {
  // Do we need to call this all the time?
  // console.log(message);
}
